import Vue from 'vue'
import VueRouter from 'vue-router'
// 路由
import serve_route from './serve.js'
import account_route from './account.js'
import setting_route from './setting.js'
import video_route from './video.js'
import manage_route from './manage.js'
import appove_route from './appove.js'
import serveuse_route from './serve_use.js'
import servepro_route from './serve_pro.js'
import message_route from './message.js'
import log_route from "./log.js"



const Home = (resolve) => { require(["@/views/layout/Home.vue"], resolve); }
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "/",
  },
  {
    path: "/join-ok",
    name: "JoinOk",
    component: (resolve) => {
      require(["@/views/layout/join-ok.vue"], resolve);
    },
  },
  {
    path: "/user-center",
    name: "/UserCenter",
    component: (resolve) => {
      require(["@/views/login/UserCenter.vue"], resolve);
    },
  },
  {
    path: "/login",
    name: "login",
    component: (resolve) => { require(["@/views/login/Login.vue"], resolve); },
    meta: { title: "登录" },
  },
  {
    path: "/404",
    name: "404",
    component: (resolve) => { require(["@/components/tip/404.vue"], resolve); },
    meta: { title: "auth" },
  },
  {
    path: '/home',
    name: 'home',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [
      {
        path: "/no-auth",
        name: "NoAuth",
        component: (resolve) => { require(["@/components/tip/no-auth.vue"], resolve); },
        meta: {
          navtype: 0
        }
      },
    ]
  },
  {
    path: "/pagetip",
    name: "pagetip",
    component: (resolve) => { require(["@/components/tip/pageTip.vue"], resolve); },
    meta: { title: "auth" },
  },
  {
    path: "/over",
    name: "over",
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    redirect: { path: "/overview" },
    children: [
      {
        path: "/overview",
        name: "overview",
        component: (resolve) => { require(["@/views/manage/overview/Overview.vue"], resolve); },
        meta: {
          public: false,
          title: '资产视图',
          id: [10023],
          navtype: 2,
          active: ['/overview'],
        },
      }
    ]
  },
  {
    path: '/serve',
    name: 'serve',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...serve_route]
  },
  {
    path: '/log',
    name: 'log',
    component: (resolve) => {
      require(["@/views/layout/Home.vue"], resolve);
    },
    children: [...log_route]
  },
  {
    path: '/serviceuse',
    name: 'serviceuse',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...serveuse_route]
  },
  {
    path: '/servicepro',
    name: 'servicepro',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...servepro_route]
  },
  {
    path: '/message',
    name: 'message',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...message_route]
  },
  {
    path: '/resourse',
    name: 'resourse',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...video_route]
  },
  {
    path: '/user',
    name: 'user',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...account_route]
  },
  {
    path: '/setup',
    name: 'setup',
    component: (resolve) => { require(["@/views/layout/Home.vue"], resolve); },
    children: [...setting_route]
  },
  {
    path: '/manage',
    name: 'manage',
    redirect: '/manage/applist',
    component: Home,
    meta: { title: "应用管理" },
    children: [...manage_route]
  },
  {
    path: '/appove',
    name: 'appove',
    component: Home,
    // meta: { title: "配额审批" },
    children: [...appove_route]
  },
]

// 避免当前位置的冗余导航
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router


